import { Box, Button, Typography } from "@mui/joy";
import LockIcon from "@mui/icons-material/Lock";
import StarIcon from '@mui/icons-material/Star';
import { getUser } from "../api/auth";
import {useNavigate} from "react-router-dom";

export default function ScopePremiumContent({ scope, children }: { scope: string, children: any }) {
    const navigate = useNavigate();
    const user = getUser();
    return (
        user?.scopes?.includes(scope) ? (
            children

        ) : (
            <Box
                className={'mt-3 mb-3'}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    width: '100%',
                    maxWidth: '100%',
                    borderRadius: '12px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                    padding: '2rem',
                    boxSizing: 'border-box',
                    background: 'linear-gradient(135deg, #FFF, #FFFDFA)',
                }}

            >
                <LockIcon sx={{ fontSize: 48, mb: 2, color: '#FF7720' }} />
                <Typography level="h4" sx={{ color: 'black', mb: 2, fontWeight: 'bold' }}>
                    Contenu Premium
                </Typography>
                <Typography sx={{ color: 'black', mb: 4, textAlign: 'center' }}>
                    Pour accéder à cette statistique avancée
                </Typography>
                <Button
                    variant="solid"
                    startDecorator={<StarIcon />}
                    sx={{
                        backgroundColor: '#FF7720',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: '#FD401A',
                        },
                    }}
                    onClick={() => {navigate('/tarifs')}}
                >
                    Abonnez-vous au plan supérieur
                </Button>
            </Box>
        )
    )

}

